import { Head } from '@inertiajs/react';
import { MainLayout } from '../../layouts/MainLayout';
import { EduHero } from '../../components/educacion-landing/EduHero';
import { SocialProof } from '../../components/educacion-landing/SocialProof';
import { WhyNutrition } from '../../components/educacion-landing/WhyNutrition';
import { ProblemSection } from '../../components/educacion-landing/ProblemSection';
import { EduStandard } from '../../components/educacion-landing/EduStandard';
import { Professionalize } from '../../components/educacion-landing/Professionalize';
import { TargetAudience } from '../../components/educacion-landing/TargetAudience';
import { EduProducts } from '../../components/educacion-landing/EduProducts';
import { FinalCTA } from '../../components/educacion-landing/FinalCTA';
import { SEOBlock } from '../../components/educacion-landing/SEOBlock';
import type { EducacionLandingProps } from '../../types/educacion-landing';

export default function EducacionLanding({ stats, featuredProducts, appUrl, loginUrl, whatsappUrl }: EducacionLandingProps) {
  return (
    <MainLayout>
      <Head>
        <title>Frutas y Verduras para Instituciones Educativas | Abasto Virtual</title>
        <meta
          name="description"
          content="Proveedor de frutas y verduras frescas para colegios, jardines y universidades en Córdoba. Entrega programada, facturación y calidad constante."
        />
        <link rel="canonical" href={`${appUrl}/educacion`} />
      </Head>

      <EduHero loginUrl={loginUrl} whatsappUrl={whatsappUrl} />
      <SocialProof stats={stats} />
      <WhyNutrition />
      <ProblemSection />
      <EduStandard />
      <Professionalize />
      <TargetAudience />
      <EduProducts products={featuredProducts} />
      <FinalCTA loginUrl={loginUrl} whatsappUrl={whatsappUrl} />
      <SEOBlock appUrl={appUrl} />
    </MainLayout>
  );
}
